export const FILTER_DRAWER_WIDTH = 262;
